module.exports = __webpack_public_path__ + "img/img04.75c0f456.jpeg";